export const SET_TRACKED_CAMERA_OPTIONS = 'SET_TRACKED_CAMERA_OPTIONS';

export const SET_MAP_LOADED = 'SET_MAP_LOADED';
export const SET_MAP_GLOBAL_PADDING = 'SET_MAP_GLOBAL_PADDING';
export const SET_MAP_POSITION = 'SET_MAP_POSITION';
export const SET_MAP_FIT_BOUNDS = 'SET_MAP_FIT_BOUNDS';

export const SET_MAP_PROPERTIES = 'SET_MAP_PROPERTIES';

export const SET_DRAW_MODULE = 'SET_DRAW_MODULE';

// Set Redux based on changes on the map
export const SET_DRAW_FEATURES = 'SET_DRAW_FEATURES'; // Combination of the two below
export const SET_DRAWN_FEATURES = 'SET_DRAWN_FEATURES';
export const SET_SAVED_DRAWN_FEATURES = 'SET_SAVED_DRAWN_FEATURES';
export const CLEAR_SAVED_DRAWN_FEATURES = 'CLEAR_SAVED_DRAWN_FEATURES';
export const SET_DRAWING_FEATURE = 'SET_DRAWING_FEATURE';
export const SET_DRAWN_FEATURE_COORDINATES = 'SET_DRAWN_FEATURE_COORDINATES';
export const SET_DRAWING_MODULE_MODE = 'SET_DRAWING_MODULE_MODE';
export const SET_DRAWING_MODULE_IDLE = 'SET_DRAWING_MODULE_IDLE';
export const SET_REFRESH_MAP = 'SET_REFRESH_MAP';
export const SET_SHAPE_FEATURE_PROPERTY = 'SET_SHAPE_FEATURE_PROPERTY';

export const SAVE_DRAWN_FEATURE_REQUEST = 'SAVE_DRAWN_FEATURE_REQUEST';
export const SAVE_DRAWN_FEATURE_SUCCESS = 'SAVE_DRAWN_FEATURE_SUCCESS';
export const SAVE_DRAWN_FEATURE_FAILURE = 'SAVE_DRAWN_FEATURE_FAILURE';

export const UPDATE_DRAWN_FEATURE_REQUEST = 'UPDATE_DRAWN_FEATURE_REQUEST';
export const UPDATE_DRAWN_FEATURE_SUCCESS = 'UPDATE_DRAWN_FEATURE_SUCCESS';
export const UPDATE_DRAWN_FEATURE_FAILURE = 'UPDATE_DRAWN_FEATURE_FAILURE';

export const DELETE_DRAWN_FEATURE_REQUEST = 'DELETE_DRAWN_FEATURE_REQUEST';
export const DELETE_DRAWN_FEATURE_SUCCESS = 'DELETE_DRAWN_FEATURE_SUCCESS';
export const DELETE_DRAWN_FEATURE_FAILURE = 'DELETE_DRAWN_FEATURE_FAILURE';

export const FETCH_DRAWN_FEATURES_REQUEST = 'FETCH_DRAWN_FEATURES_REQUEST';
export const FETCH_DRAWN_FEATURES_SUCCESS = 'FETCH_DRAWN_FEATURES_SUCCESS';
export const FETCH_DRAWN_FEATURES_FAILURE = 'FETCH_DRAWN_FEATURES_FAILURE';
